import { Link } from "react-router-dom";
import styled from "styled-components";
import { media } from "../../../../../../styles/Qtheme";

export const MenuLi = styled.li`
  height: 100%;
  position: relative;

  & * {
    transition: all 0.3s;
  }

  & ul {
    display: none;
    opacity: 0;
  }

  &:hover > * {
    color: ${({ theme }) => theme.COLORS.memuHover};
  }

  &:hover ul {
    opacity: 1;
    display: block;
  }
`;

export const Menu = styled(Link)`
  display: block;
  height: 100%;
  font-size: 14px;
  font-weight: 700;
  line-height: 16.71px;
  color: ${({ theme }) => theme.text};
  display: flex;
  align-items: center;
  gap: 6px;
  font-family: "Pretendard", sans-serif;

  z-index: 11000;

  @media (max-width: 1700px) {
    font-size: 14px;
  }
`;

export const SubMenuWrap = styled.div`
  border-radius: 10px;
  position: absolute;
  top: 10px;
  left: -22px;
  z-index: 10999;

  &.hover {
    z-index: 10998;
  }

  @media ${media.desktop} {
    display: none;
  }
`;

export const SubMenu = styled.ul`
  width: 380px;
  margin-top: 20px;
  background-color: ${({ theme }) => theme.subMenu};
  box-shadow: ${({ theme }) => theme.subMenuShadow};

  @media ${media.desktop} {
    display: none;
  }
`;

export const SubMenuList = styled.li`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 5px;

  transition: all 0.3s;

  &.inactive * {
    color: ${({ theme }) => theme.COLORS.memuHover};
  }

  a {
    display: block;
    width: 100%;
    height: 100%;
    padding: 15.5px 30px;
    gap: 10px;

    h4 {
      font-size: 16px;
      font-weight: 700;
      color: ${({ theme }) => theme.text};
    }

    p {
      margin-top: 5px;
      font-size: 14px;
      font-weight: 400;
      color: #b7b7b7;
    }
  }

  &:hover {
    background-color: ${({ theme }) => theme.COLORS.subMenuHover};

    a {
      h4 {
        color: ${({ theme }) => theme.menuTextHover};
      }
    }
  }
`;
